module.exports = __webpack_public_path__ + "static/media/68.c80509ce.png";